// Synchroniser avec les variables CSS `:root` dans src/index.css
// (utilisées par les styles globaux body/a/scrollbar).
export const calmTokens = {
  bg: '#0d0d10',
  surface: '#16161b',
  surface2: '#1d1d24',
  surfaceH: '#20202a',

  border: 'rgba(255,255,255,0.06)',
  borderS: 'rgba(255,255,255,0.09)',

  text: '#f2f2f4',
  textDim: '#a3a3ad',
  textMute: '#6b6b76',

  accent: '#a5b4fc',
  accentDim: 'rgba(165,180,252,0.14)',
  accentStrong: '#6366f1',
  accentSoft: '#c7d2fe',

  debit: '#fca5a5',
  debitDim: 'rgba(252,165,165,0.08)',
  debitBorder: 'rgba(252,165,165,0.18)',

  credit: '#86efac',
  creditDim: 'rgba(134,239,172,0.08)',
  creditBorder: 'rgba(134,239,172,0.18)',
  creditSoft: '#bbf7d0',

  warn: '#fde047',

  fontUi: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  fontDisp: "'Fraunces', 'Inter', serif",
  fontMono: "'JetBrains Mono', 'SF Mono', ui-monospace, monospace",
};
